import React from 'react';

export const Hero = () => {
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    // Fade in hero content after mount
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollToBooking = () => {
    const bookingSection = document.getElementById('booking');
    if (bookingSection) {
      const navHeight = 80; // Account for fixed navigation
      const targetPosition = bookingSection.getBoundingClientRect().top + window.pageYOffset - navHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden bg-[#071936]">
      {/* SINGLE HERO IMAGE - Pod Exterior - Optimized loading */}
      <img
        src="https://customer-assets.emergentagent.com/job_coastal-leitrim/artifacts/z7zecblz_Exterior.jpeg"
        alt="The Tullaghan Pod - Cosy glamping pod with ocean views on the Wild Atlantic Way"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
        fetchpriority="high"
        decoding="async"
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50 z-10"></div>

      {/* Content - Smooth fade in */}
      <div className={`relative z-20 h-full flex items-center justify-center px-5 sm:px-6 transition-all duration-1000 ${
        isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}>
        <div className="max-w-2xl mx-auto text-center space-y-5 sm:space-y-6 w-full">
          {/* Label */}
          <div>
            <span className="text-white/90 text-[11px] sm:text-xs tracking-[0.2em] uppercase font-light">
              Coastal Glamping Retreat
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-[32px] sm:text-4xl md:text-5xl lg:text-6xl font-light text-white leading-[1.15] px-4">
            A Private Coastal Retreat on the Wild Atlantic Way
          </h1>

          {/* Subtext */}
          <p className="text-[15px] sm:text-base md:text-lg text-white/95 font-light max-w-xl mx-auto leading-relaxed px-4">
            Adults-only glamping for two with sea views and a wood-fired hot tub
          </p>

          {/* CTA - Premium button with soft depth */}
          <div className="pt-4 sm:pt-6 px-4">
            <button
              onClick={scrollToBooking}
              className="w-full sm:w-auto min-w-[240px] px-10 py-4 bg-[#2AA7A1] text-white font-medium transition-all duration-200 ease-out text-base shadow-[0_2px_8px_rgba(42,167,161,0.2)] hover:shadow-[0_4px_16px_rgba(42,167,161,0.3)] hover:-translate-y-[2px] active:translate-y-[0px]"
            >
              Check Availability
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
